<app-header></app-header>
<div id="auth" class="container-fluid">
  <div id="box_auth">
    <form action="" method="post">
      <div class="title_auth margin-0">{{'Validation' | translate}}</div>
      <div class="excerpt_auth">{{'SendCodeTo' | translate}} <span>«{{user.mobile}}» </span>{{'Sended' | translate}}</div>
      <div class="box_auth_row">
        <input type="text" id="verify_code" name="verify_code" placeholder="{{'VerifyCode' | translate}}" [(ngModel)]="user.mobile_token" (keyup.enter)="login()">
      </div><!-- .login_row -->
      <div class="box_auth_row">
        <div class="pull-left">
          <button type="button" (click)="login()">
            {{'confirm' | translate}}
            <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="registerSpinner"></mat-spinner>
          </button>
        </div>
        <div class="auth_links">
          <div class="the_link">
            <a class="verify_resend_code" (click)="resendCode()">
              {{'ResendVerificationCode' | translate}}
              <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;stroke: red;" matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="resendCodeSpinner"></mat-spinner>
            </a>
          </div>
          <div>
            <a [routerLink]="['/login']">{{'Return' | translate}}</a>
          </div>
        </div>
        <div class="clearfix"></div>
      </div><!-- .login_row -->
    </form>
  </div><!-- .box_auth -->
</div><!-- #auth -->
<app-footer></app-footer>
